/**
 * PATH: packages/email-hub/src/feature/components/filter-sidebar/expansion.ts
 * FILE_ID: EMAILHUB-FILTERSIDEBAR-EXPANSION-001
 * PURPOSE: Persists the filter sidebar's expanded section state.
 */
import type { ExpandState } from './types'

const DEFAULT_EXPAND: ExpandState = {
  saved: true,
  category: true,
  mailbox: true,
  job: true,
  sender: false,
  date: false,
  flags: false,
  status: true,
  tags: false,
}

/** Stable storage key for the expand-state map so a user's chosen
 *  layout persists across reloads. */
const EXPAND_STORAGE_KEY = 'email_filter_sidebar_expanded_v1'

export function loadExpand(): ExpandState {
  if (typeof window === 'undefined') return DEFAULT_EXPAND
  try {
    const raw = window.localStorage.getItem(EXPAND_STORAGE_KEY)
    if (!raw) return DEFAULT_EXPAND
    const parsed = JSON.parse(raw)
    return { ...DEFAULT_EXPAND, ...parsed }
  } catch {
    return DEFAULT_EXPAND
  }
}

export function saveExpand(state: ExpandState) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(EXPAND_STORAGE_KEY, JSON.stringify(state))
  } catch {
    // ignore quota errors
  }
}

export function countActive(f: import('./types').SidebarFilters): number {
  let n = 0
  if (f.category) n++
  if (f.isRead !== undefined) n++
  if (f.isStarred !== undefined) n++
  if (f.jobIds?.length) n++
  if (f.mailboxKeys?.length) n++
  if (f.fromAddressContains) n++
  if (f.receivedAtGte || f.receivedAtLte) n++
  if (f.hasAttachments !== undefined) n++
  if (f.hasCalendarEvent !== undefined) n++
  return n
}
